import { styled } from 'styled-components';

const StyledContainer = styled.div`
  ${({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100dvh;
  padding: ${theme.padding}px;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(
      circle at ${theme.opacityImage * 20}% ${theme.opacityImage * 80}%,
      ${theme.colorPrimary}${theme.opacityImage * 80} 0%,
      transparent ${theme.opacityImage * 50}%
    ),
    radial-gradient(
      circle at ${theme.opacityImage * 80}% ${theme.opacityImage * 20}%,
      ${theme.colorPrimary}${theme.opacityImage * 60} 0%,
      transparent ${theme.opacityImage * 50}%
    ),
    radial-gradient(
      circle at ${theme.opacityImage * 40}% ${theme.opacityImage * 40}%,
      ${theme.colorPrimary}${theme.opacityImage * 70} 0%,
      transparent ${theme.opacityImage * 50}%
    );
  background-color: ${theme.colorBgContainer};
  animation: gradientMove 25s ease infinite;

  @keyframes gradientMove {
    0% {
      background-position: 0% 0%;
    }
    50% {
      background-position: 100% 100%;
    }
    100% {
      background-position: 0% 0%;
    }
  }
  background-size: 200% 200%;
`}
`;

interface UnauthenticatedLayoutProps {
  children: React.ReactNode;
}

const UnauthenticatedLayout = ({ children }: UnauthenticatedLayoutProps) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export default UnauthenticatedLayout;
